import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        // Manifesto: bg #FFE4E6 + text #881337 (vinho)
        default: "bg-[#FFE4E6] text-[#881337]",
        wine: "bg-[#881337] text-white",
        // Premium destaque — bg dourado 14% opacity + text vinho.
        gold: "bg-[rgba(245,158,11,0.14)] text-[#881337]",
        success: "bg-green-100 text-green-700",
        warning: "bg-yellow-100 text-yellow-700",
        error: "bg-red-100 text-red-700",
        gray: "bg-gray-100 text-gray-600",
        outline: "border border-[#E11D48] text-[#881337] bg-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
